import { Route } from '@angular/router';
import { authGuard } from '@com.maessa.payroll.frontend/auth';

export const appRoutes: Route[] = [
  { path: '', redirectTo: 'work-sheets', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'work-sheets',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/work-sheets/daily-sheet/daily-sheet.component').then(
            (m) => m.DailySheetComponent
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./features/work-sheets/sheet-status/sheet-status.component').then(
            (m) => m.SheetStatusComponent
          ),
      },
    ],
  },
  {
    path: 'my-team',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/my-team/team-view.component').then((m) => m.TeamViewComponent),
  },
  { path: '**', redirectTo: 'work-sheets' },
];
